import React from "react";
import { ShieldCheckIcon, DocumentTextIcon, EnvelopeIcon } from "@heroicons/react/24/outline";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

const PrivacyPolicyAata = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen h-full bg-gray-50 overflow-y-scroll">
      <div className="container mx-auto px-4 py-12 max-w-4xl">
        <header className="mb-8 border-b border-gray-200 pb-6">
          <button
            onClick={() => navigate("/")}
            className="flex items-center text-indigo-600 hover:text-indigo-800 transition font-medium mb-4"
          >
            <ArrowLeft className="w-5 h-5 mr-2" />
            Back to Home
          </button>
          <div className="flex items-center gap-3 mb-4">
            <ShieldCheckIcon className="h-8 w-8 text-blue-600" />
            <h1 className="text-3xl font-bold text-gray-900 font-serif">Privacy Policy</h1>
          </div>
        </header>

        <div className="bg-white rounded-lg shadow-sm p-8">
          <section className="mb-10">
            <p className="text-gray-600 mb-6 leading-relaxed">
              This Privacy Policy governs the manner in which <strong>AATA CHAKKI</strong>, developed and published by <strong>MAD GAMES STUDIOS</strong>, collects, uses, maintains, and discloses information collected from users of the AATA CHAKKI mobile application (“App”). This policy applies to the App and all products and services offered by MAD GAMES STUDIOS.
            </p>
          </section>

          {[
            {
              title: "1. Information We Collect",
              content: "We may collect personal and business-related information required to operate the App, including but not limited to contact details, transaction records, device identifiers, and usage data, when you use the App."
            },
            {
              title: "2. Use of Information",
              content: "We use collected information to provide, improve, and maintain our services, deliver features, communicate with users, and fulfill legal obligations."
            },
            {
              title: "3. Data Security",
              content: "We implement appropriate administrative, technical, and physical safeguards to protect user data. However, no method of transmission or storage is 100% secure."
            },
            {
              title: "4. Data Sharing",
              content: "We may share information with service providers, legal authorities when required by law, and during business transitions such as mergers or acquisitions."
            },
            {
              title: "5. Your Rights",
              content: "You can request access, correction, deletion, or data export for your personal information."
            },
            {
              title: "6. Changes to This Policy",
              content: "We may update this Privacy Policy. If material changes occur, we will notify you by in-app notification or email."
            }
          ].map((section, index) => (
            <section key={index} className="mb-8">
              <div className="flex items-baseline gap-2 mb-3">
                <DocumentTextIcon className="h-5 w-5 text-blue-600 flex-shrink-0" />
                <h2 className="text-xl font-semibold text-gray-900">{section.title}</h2>
              </div>
              <p className="text-gray-600 ml-7 leading-relaxed">{section.content}</p>
            </section>
          ))}

          <div className="mt-10 p-6 bg-blue-50 rounded-lg">
            <div className="flex items-start gap-3">
              <EnvelopeIcon className="h-6 w-6 text-blue-600 flex-shrink-0" />
              <div>
                <h3 className="font-semibold text-gray-900 mb-2">Contact Information</h3>
                <p className="text-gray-600">
                  For privacy concerns or data requests:<br />
                  Email: <span className="text-blue-600">sonushilla89@gmail.com</span><br />
                  Developer: <span className="text-blue-600">MAD GAMES STUDIOS</span><br />
                  Address: <span className="text-blue-600">[Your Company Address]</span>
                </p>
              </div>
            </div>
          </div>

          <footer className="mt-8 pt-6 border-t border-gray-200">
            <p className="text-sm text-gray-500 text-center">
              © {new Date().getFullYear()} MAD GAMES STUDIOS. All rights reserved.
            </p>
          </footer>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyAata;
